import script from "./CartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CartComponent.vue?vue&type=style&index=0&id=e4c23dac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c23dac"]])

export default __exports__